import { useEffect, useState } from "react";
import { IconContext } from "react-icons";
import { BiTimer } from "react-icons/bi";

import "./style.less";

function formatTime(totalSeconds: number): string {
  const days = Math.floor(totalSeconds / 86400);
  const h = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, "0");
  const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const s = String(totalSeconds % 60).padStart(2, "0");

  const hms = `${h}:${m}:${s}`;
  return days > 0 ? `${days}d ${hms}` : hms;
}

export function Timer() {
  const [seconds, setSeconds] = useState<number>(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="Timer-component">
      <IconContext.Provider
        value={{ color: "#ffffff", className: "icon", size: "1.5em" }}
      >
        <BiTimer />
      </IconContext.Provider>
      <span>{formatTime(seconds)}</span>
    </div>
  );
}
